import {Component, Input} from '@angular/core';
import {EstadoOnboardingPainel} from '../onboarding-painel.service';

/**
 * Oferta por concluir os primeiros passos: mensalidade promocional nos três primeiros meses pagos, se o teste for
 * concluído dentro do teste grátis. Destaque no hub, faixa no alto de cada passo, reforço no botão de concluir.
 * Prazo vencido sem garantir: some (não promete o que não vale mais).
 */
@Component({
  selector: 'app-onb-bonus',
  templateUrl: './onb-bonus.component.html',
  styleUrls: ['./onb-bonus.component.scss']
})
export class OnbBonusComponent {
  @Input() estado: EstadoOnboardingPainel;
  @Input() formato: 'destaque' | 'faixa' | 'final' | 'cartao' = 'destaque';

  get bonus(): any { return this.estado?.bonus || null; }

  get garantido(): boolean { return !!this.bonus?.garantido; }

  get visivel(): boolean { return !!this.bonus && (this.bonus.garantido || this.bonus.disponivel); }

  get promocional(): boolean { return Number(this.bonus?.meses) > 1; }

  get valor(): string { return this.moeda(Number(this.bonus?.valor || 0)); }

  get beneficio(): string { return this.promocional ? `${this.valor}/mês` : `${this.valor} de desconto`; }

  get periodo(): string {
    return this.promocional ? `nos ${this.bonus.meses} primeiros meses pagos, após o teste grátis` : 'na primeira mensalidade';
  }

  get depois(): string {
    return this.promocional && this.bonus?.valorRegular
      ? `A partir do ${Number(this.bonus.meses) + 1}º mês, ${this.moeda(Number(this.bonus.valorRegular))}/mês pelo plano. Serviços adicionais são cobrados à parte.` : '';
  }

  private moeda(valor: number): string { return valor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}); }

  get prazo(): string {
    const p = this.bonus?.prazo;
    return p ? new Date(p).toLocaleDateString('pt-BR', {day: '2-digit', month: '2-digit'}) : '';
  }

  get dias(): number {
    const p = this.bonus?.prazo ? new Date(this.bonus.prazo).getTime() : 0;
    return p ? Math.max(0, Math.ceil((p - Date.now()) / 86400000)) : 0;
  }

  /** cartão do bônus: "Expira em 3 dias", "Expira amanhã", "Expira hoje" */
  get textoExpira(): string {
    if (this.dias <= 0) return 'Expira hoje';
    return this.dias === 1 ? 'Expira amanhã' : `Expira em ${this.dias} dias`;
  }

  get textoConclua(): string {
    if (!this.prazo) return 'Conclua os primeiros passos';
    return this.dias <= 0 ? 'Conclua hoje' : `Conclua até ${this.prazo}`;
  }

  get textoDias(): string {
    if (!this.prazo) return '';
    if (this.dias <= 0) return `até hoje (${this.prazo})`;
    return `até ${this.prazo} · ${this.dias === 1 ? 'falta 1 dia' : 'faltam ' + this.dias + ' dias'}`;
  }

  /** a faixa diz uma condição só: concluir até o fim do teste grátis */
  get textoAte(): string {
    if (!this.prazo) return '';
    return this.dias <= 0 ? ' hoje' : ` até ${this.prazo}`;
  }

  get faltam(): number { return Math.max(0, (this.estado?.total || 6) - (this.estado?.feitos || 0)); }

  get textoFaltam(): string {
    if (!this.faltam) return 'Tudo pronto: conclua o pedido de teste';
    return this.faltam === 1 ? 'Falta 1 passo' : `Faltam ${this.faltam} passos`;
  }
}
